/**
 * Instants, rendered in the one zone this business operates in — Task 13.2.
 *
 * Extracted from `content/ContentListPage.tsx`, where it was defined beside a content table and imported by
 * three other content modules. The support queue needs the same thing for the same reason, and a second
 * `Intl.DateTimeFormat` with the same options is a second place for the zone to drift.
 *
 * The zone is fixed rather than taken from the browser. A dashboard is operated from Puerto Rico about events
 * that happened in Puerto Rico, and a staff member checking a queue from elsewhere needs the shop's clock,
 * not their own. The label is rendered beside the value so the reading is never ambiguous.
 */
import { contentDisplayTimeZone, type UtcInstant } from '@apuestapr/contracts';

export const puertoRicoZoneLabel = 'Hora de Puerto Rico (AST, UTC−4)' as const;

const puertoRicoFormatter = new Intl.DateTimeFormat('es-PR', {
  dateStyle: 'medium',
  timeStyle: 'short',
  timeZone: contentDisplayTimeZone,
});

export const formatPuertoRicoInstant = (instant: UtcInstant): string =>
  puertoRicoFormatter.format(new Date(instant));
